import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Backdrop from '../../../generic-components/Backdrop';
import Icon from '../../../generic-components/Icon';
import { DownArrowBold } from '../../../assets/svg';

interface IState {
  STATE: string;
  POSTAL: string;
}

interface IProps {
  items: IState[];
  onClick: (value: string, index: number) => void;
  id: string;
  additionalClassName?: string;
  current: number;
}

const DropdownStatesList = ({ items, onClick, id, additionalClassName, current }: IProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleClose = () => {
    setDropdownOpen(false);
  };
  const { t } = useTranslation();
  return (
    <div className='relative w-[170px] h-[44px]' id={id}>
      {dropdownOpen && <Backdrop onClick={handleClose} />}
      <button
        id={`dropdownOpen${id}`}
        data-dropdown-toggle='dropdown'
        className={`${additionalClassName ?? ''} w-full h-full bg-bw02 focus:border-action03 font-metric border border-bw03 rounded-md text-sm inline-flex items-center px-[10px] flex justify-between`}
        type='button'
        onClick={() => setDropdownOpen(true)}
      >
        <span className={`${current === -1 ? 'text-bw06' : 'text-bw08'} font-metric text-sm`}>
          {current !== -1 ? items[current].POSTAL : t('ORDER_NEW_CARD_PLACEHOLDER_STATE')}
        </span>
        <Icon src={DownArrowBold} className='pl-2' />
      </button>
      {dropdownOpen && (
        <div
          id={`dropdown${id}`}
          className='absolute top-[-281px] left-[170px] z-40 bg-bw00 text-bw07 divide-y divide-gray-100 rounded shadow h-[325px] w-[164px] overflow-auto rounded-xl'
        >
          <ul className='text-sm text-gray-700'>
            {items?.map((item, index) => (
              <li
                id={`dropdownOption${index}`}
                data-testid={item.POSTAL}
                role='presentation'
                key={item.POSTAL}
                onClick={() => {
                  if (onClick) {
                    onClick(item.POSTAL, index);
                  }
                  setDropdownOpen(false);
                }}
                className={`${index === current ? '' : ''} text-sm flex items-center justify-between h-[32px] px-[10px] cursor-pointer text-bw08 font-metric bg-bw00 hover:bg-bw02 hover:font-metricMedium hover:text-action03`}
              >
                <span>{item.STATE}</span>
                <span>{item.POSTAL}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default DropdownStatesList;
